module.exports = __webpack_public_path__ + "54718315555a52bd5c4909df28ea37bf.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/age-gate-bg-320.webp.png
// module id = 169
// module chunks = 0